import { InjectionToken } from '@angular/core';
import { DashboardWidgetRegistration } from '../models/dashboard-widget.types';

export const DASHBOARD_WIDGETS = new InjectionToken<DashboardWidgetRegistration[][]>('DASHBOARD_WIDGETS');
